import React, { useState,useEffect } from 'react';
import { Modal, Button } from 'rsuite';

import { useSelector, useDispatch } from 'react-redux';

import {agregarCliente} from "../../actions/clientes"


function AgregarCliente(props) {
    const {modal, idProveedor, setModalAgregar}=props
    const dispatch = useDispatch();
    const [imput,setImput]=useState({
        nombre:"",
        direccion:"",
        telefono:"",
    });

    const restric = useSelector((state) => state.reducerBusqueda );
    
    const [show, setShow] = useState(modal != null);

    useEffect(() => {
      setShow(modal != null)
    }, [modal])

    const valorImput = (e) =>{
          setImput({
            ...imput,
            [e.target.name]: e.target.value})       
    }
  
    const handleClose = () => {
            console.log(idProveedor)
            if(imput.direccion=="" || imput.nombre=="" || imput.telefono == ""){
              
            }else{
              const dato = {
                 nombre : imput.nombre,
                 telefono: imput.telefono,
                 direccion: imput.direccion,
              }
              dispatch(agregarCliente(dato))
              setModalAgregar(null)
              setShow(false);
              setImput({
                nombre:"",
                direccion:"",
                telefono:""
            })
            ;}
    };
    const handleCloseButton=()=>{
      setModalAgregar(null)
      setShow(false);
      setImput({
        nombre:"",
        direccion:"",
        telefono:""
    })
    } 
       
    const handleShow = () => setShow(true);

    return (
      <>
         {(show) &&
  
        <Modal open={show} onClose={handleCloseButton}>
          <Modal.Header >
            <Modal.Title>+Agregar Cliente</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <h3>Nombre:</h3>
              <div className="form-group">
              <input type="text" className="form-control input-sm" onChange={valorImput} value={imput.nombre} name="nombre" min={1}   required ></input>
              </div> 
              <h3>Direccion:</h3>
              <div className="form-group">
              <input type="text" className="form-control input-sm" onChange={valorImput} value={imput.direccion} name="direccion" min={1}   required ></input>
              </div> 
              <h3>Telefono:</h3>
              <div className="form-group">
              <input type="number" className="form-control input-sm" onChange={valorImput} value={imput.telefono} name="telefono" min={1}   required ></input>
              </div>                                    
          </Modal.Body>
          <Modal.Footer>
            <Button appearance="primary" color="red" onClick={handleCloseButton}>
              Cerrar
            </Button>
            <Button  appearance="primary" type="submit" onClick={handleClose}>
              Agregar
            </Button>
          </Modal.Footer>
        </Modal>
         }
         
      </>
    );
  }
  
  export default AgregarCliente;